// store/slices/interStoreProductSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Product {
  gst: number;
  id: string;
  styleNumber?: string;
  materialType?: string;
  karatType?: string;
  ktId?: number;
  category?: string;
  netWeight?: number;
  size?: string;
  dpPrice?: number;
  huid?: string;
  isSrp?: boolean;
  stonePrice?: number;
  customerAmount: number;
}

interface ProductState {
  products: Product[];
}

const initialState: ProductState = {
  products: [],
};

const interStoreProductSlice = createSlice({
  name: "interStoreProduct",
  initialState,
  reducers: {
    setProducts: (state, action: PayloadAction<Product[]>) => {
      state.products = action.payload;
    },
    addProduct: (state, action: PayloadAction<Product>) => {
      state.products.push(action.payload);
    },
    clearProducts: (state) => {
      state.products = [];
    },
  },
});

export const { setProducts, addProduct, clearProducts } = interStoreProductSlice.actions;
export default interStoreProductSlice.reducer;
